import { Provider } from '@angular/core';
// Form components
import { ElementComponent, FormComponent, MessagesComponent } from './form/components';
import { ButtonComponent, InputComponent, MediaComponent, SelectComponent, TextareaComponent } from './elements';
import { KeyValueComponent } from './elements/components/key-value/key-value.component';
import { ValidationConfigComponent } from './elements/components/validation-config/validation-config.component';
import { PermissionsComponent } from './elements/components/permissions/permissions.component';
import { TreeComponent } from './elements/components/tree/tree.component';
import { FormLayoutComponent } from './components/form-layout/form-layout';
import { WysiwygComponent } from './elements/components/wysiwyg/wysiwyg.component';
import { ColorPickerComponent } from './elements/components/color-picker/color-picker.component';
import { Select2Component } from '@kaiser-software/chassis-core/src/app/forms/elements/components/select-2/select.component';

export const FormComponents: Provider[] = [
    FormLayoutComponent,

    // Form
    FormComponent,
    MessagesComponent,
    ElementComponent,

    // Form elements
    ButtonComponent,
    InputComponent,
    TextareaComponent,
    SelectComponent,
    Select2Component,
    MediaComponent,
    TreeComponent,
    ColorPickerComponent,

    // RelationComponent,
    WysiwygComponent,

    // extra components
    KeyValueComponent,
    ValidationConfigComponent,
    PermissionsComponent

];



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form.components.ts